import { Grid, Stack } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import { useBranches } from "../../../hooks/branch";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { getBranchDetails } from "../../../services/Branches";
import { getAllServices } from "../../../services/Services";
import {
  createTeamMember,
  deleteTeams,
  fetchAllTeamMembers,
  updateTeamMembers,
} from "../../../services/Team";
import OpeningHours from "../../auth/branchSignupSteps/OpeningHours";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import AddNewMember from "./AddNewMember";
import ProvideService from "./ProvideService";
import Sheduling from "./Shedule";
import TeamMembers from "./TeamMembers";
import { useLocation } from "react-router-dom";

const tabs = [
  { label: "Team members", value: "teamMemebrs" },
  { label: "Scheduled shifts", value: "sheduleShift" },
];

function convertISOToDate(isoString) {
  return dayjs(isoString);
}
const daysss = [
  {
    id: 1,
    name: "Monday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 2,
    name: "Tuesday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 3,
    name: "Wednesday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 4,
    name: "Thursday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 5,
    name: "Friday",
    selected: false,
    startTime: "",
    endTime: "",
  },
  {
    id: 6,
    name: "Saturday",
    selected: false,
    startTime: "",
    endTime: "",
  },
  {
    id: 7,
    name: "Sunday",
    selected: false,
    startTime: "",
    endTime: "",
  },
];
function ClientTems() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { allBranches, fetchBranches } = useBranches();
  const confirmRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [allTeamMembers, setAllTeamMembers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [serviceData, setServiceData] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedID, setSelctedID] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formData, setFormData] = useState(null);
  const [brancheTime, setBranchTime] = useState([]);
  const [completeBranchData, setCompleteBranchData] = useState(null);
  const openConfirmDialog = useRef();
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [filteredTeams, setFilteredTeams] = useState([]);
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const { user } = useSelector((state) => state.user);
  const [salaryOption, setSalaryOption] = useState({
    percentage: false,
    salary: false,
  });

  const [inputValue, setInputValue] = useState({
    images: "",
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    jobTitle: "",
    gender: "",
    address: "",
    branchId: "",
    startDate: "",
    endDate: "",
    salaryType: "",
    percentage: "",
    salary: "",
    note: "",
    timmings: [],
  });

  const [inputError, setInputError] = useState({
    images: false,
    firstName: false,
    lastName: false,
    email: false,
    contact: false,
    jobTitle: false,
    gender: false,
    address: false,
    branchId: false,
    startDate: false,
    endDate: false,
    salarytype: false,
    percentage: false,
    salary: false,
    note: false,
  });

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (selectedBranch?.length === 1) {
      fetchBranches();
      handleFetchAllTeamMembers();
    }
  }, [selectedBranch]);

  useEffect(() => {
    if (pathname == "/dashboard/team") {
      handleChangeTab("teamMemebrs")
    }
  }, [pathname]);

  useEffect(() => {
    if (!inputValue.timmings || inputValue.timmings.length === 0) {
      setInputValue((prev) => ({
        ...prev,
        timmings: formData?.teamType === "add" ? inputValue?.timmings : daysss,
      }));
    }
  }, []);

  useEffect(() => {
    const filtered = allTeamMembers.filter((team) => {
      const nameMatch = team?.firstName
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const emailMatch = team?.email
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      return nameMatch || emailMatch;
    });
    setFilteredTeams(filtered);
  }, [allTeamMembers, searchInput]);

  useEffect(() => {
    if (formData?.teamType == "edit") {
      let perSelectedTime = daysss.map((day, index) => {
        const match = formData?.timings?.find((item) => item.day === day?.name);
        return {
          name: day?.name,
          selected: !!match,
          startTime: match ? match.sTime : "",
          endTime: match ? match.eTime : "",
        };
      });

      console.log(perSelectedTime, "perSelectedTimeperSelectedTime");

      handleSetSelectedServices();
      const startDate = convertISOToDate(formData?.startDate);
      const endDate = convertISOToDate(formData?.endDate);

      setSelctedID(formData?.services);
      setInputValue({
        images: formData?.image,
        firstName: formData?.firstname,
        lastName: formData?.lastname,
        email: formData?.email,
        contact: formData?.contactNumber,
        jobTitle: formData?.jobtitle,
        gender: formData?.gender,
        address: formData?.address,
        branchId: formData?.branchID,
        startDate: startDate,
        endDate: endDate,
        salaryType: formData?.paymentType,
        percentage: formData?.paymentPercentage,
        salary: formData?.salary,
        note: formData?.notes,
        timmings: perSelectedTime,
      });
      if (formData?.paymentType == "Percentage") {
        setSalaryOption({
          percentage: true,
          salary: false,
        });
      } else {
        setSalaryOption({
          percentage: false,
          salary: true,
        });
      }
    } else {
      resetInputs();
    }
  }, [formData]);

  const handleFetchBranhDetails = async () => {
    try {
      setIsLoading(true);
      const responce = await getBranchDetails(inputValue?.branchId);
      let data = responce?.data?.data;
      console.log(data, "datadatadatadata");
      setCompleteBranchData(data);

      setIsLoading(false);

      if (responce.status == 200 || responce.status === 201) {
        if (formData?.teamType == "add") {
          setInputValue({ ...inputValue, timmings: data?.timmings });
          setBranchTime(data?.timmings);
        }
      } else {
        console.log(responce.data.message, "hEre");
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchBranhDetails ~ error:", error);
    }
  };

  const handleSetSelectedServices = () => {
    let selectedServices = formData?.services
      .map((serviceId) => {
        let matchedService = serviceData?.find((service) =>
          service?.services?.some((s) => s._id === serviceId)
        );

        return matchedService?.services?.find((s) => s._id === serviceId);
      })
      .filter(Boolean);
    setSelectedServices(selectedServices);
  };

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, teams: tab }));
  };

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
  };

  const handleFetchAllTeamMembers = async () => {
    if (selectedBranch)
      try {
        setIsLoading(true);
        const responce = await fetchAllTeamMembers(selectedBranch[0]);
        setIsLoading(false);
        if (responce.status == 200 || responce.status == 201) {
          let data = responce?.data?.data;
          setAllTeamMembers(data);
        } else {
          handleSnackbarVal(true, "error", responce?.data?.message);
        }
      } catch (error) {
        setIsLoading(false);
        console.log("🚀 ~ handleFetchAllBranches ~ error:", error);
        handleSnackbarVal(true, "error", error?.data?.message);
      }
  };

  const resetInputs = () => {
    setInputValue({
      images: "",
      firstName: "",
      lastName: "",
      email: "",
      contact: "",
      jobTitle: "",
      gender: "",
      address: "",
      branchId: "",
      startDate: "",
      endDate: "",
      salaryType: "",
      percentage: "",
      salary: "",
      note: "",
      timmings: [],
    });
    setSelctedID([]);
    setSalaryOption({ percentage: false, salary: false });
    setSelectedCategory([]);
    setSelectedServices([]);
  };

  const handleCreateTeamMember = async (row) => {
    console.log(row, "rowrowrowrow");

    const createPayload = () => {
      const {
        images,
        firstName,
        lastName,
        email,
        contact,
        jobTitle,
        gender,
        address,
        branchId,
        startDate,
        endDate,
        salaryType,
        percentage,
        salary,
        note,
      } = inputValue;

      return {
        firstname: firstName,
        lastname: lastName,
        image: images,
        email: email,
        contactNumber: contact,
        jobtitle: jobTitle,
        gender: gender,
        address: address,
        branchID: branchId,
        businessID: user?._id,
        startDate: startDate,
        endDate: endDate,
        paymentType: salaryType,
        paymentPercentage: percentage || undefined,
        salary: salary,
        notes: note,
        timings: row?.timmings,
        services: selectedID,
      };
    };

    const processResponse = (response, successMessage) => {
      setIsLoading(false);
      if (response?.status === 200 || response?.status === 201) {
        setOpenConfirm(false);
        handleChangeTab("teamMemebrs");
        handleFetchAllTeamMembers();
        resetInputs();
        handleSnackbarVal(true, "success", successMessage);
      } else {
        handleSnackbarVal(true, "error", response?.data?.message);
      }
    };

    try {
      setIsLoading(true);
      const payload = await createPayload();
      console.log(payload, "payloadpayloadpayloadpayload");

      setIsLoading(false);
      const response =
        row?.teamType !== "edit"
          ? await createTeamMember(payload)
          : await updateTeamMembers(row?._id, payload);

      processResponse(response, response?.data?.message);
    } catch (error) {
      console.log("🚀 ~ ~ error:", error);
      setIsLoading(false);
      handleSnackbarVal(
        true,
        "error",
        error?.data?.message || "An error occurred"
      );
    }
  };

  const handleDelete = async (row) => {
    confirmRef.current.isVisible({ row });
  };

  const handleEdit = (row) => {
    let data = {
      ...row,
      teamType: "edit",
    };
    setFormData(data);
    handleChangeTab("addNewMember");
  };

  const handleDeleteTeamMember = async ({ row }) => {
    try {
      setIsLoading(true);
      const responce = await deleteTeams(row?._id);
      setIsLoading(false);
      if (responce?.status == 200 || responce?.status == 201) {
        handleSnackbarVal(true, "success", responce?.data?.message);
        handleFetchAllTeamMembers();
        setOpenDialog(false);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      setIsLoading(false);
      handleSnackbarVal(true, "success", error?.data?.message);
    }
  };

  const handleFetchAllServices = async () => {
    try {
      setIsLoading(true);
      const responce = await getAllServices(inputValue?.branchId);
      setIsLoading(false);
      if (responce?.status == 200 || responce?.status == 201) {
        let data = responce?.data?.data;
        setServiceData(data);
        let selectedServices = formData?.services
          .map((serviceId) => {
            let matchedService = data?.find((service) =>
              service?.services?.some((s) => s._id === serviceId)
            );

            return matchedService?.services?.find((s) => s._id === serviceId);
          })
          .filter(Boolean);
        setSelectedServices(selectedServices);
      } else {
        // handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchCategory ~ error:", error);
      // handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleChangeStatus = async (row) => {
    try {
      let payload = {
        status: !row?.status,
      };
      setIsLoading(true);
      const responce = await updateTeamMembers(row?._id, payload);
      setIsLoading(false);

      if (responce?.status == 200 || responce?.status == 201) {
        setOpen(false);
        handleChangeTab("teamMemebrs");
        handleFetchAllTeamMembers();
        handleSnackbarVal(true, "success", responce?.data?.message);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      console.log("🚀 ~ ~ error:", error);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleSelecteTime = (updatedDays) => {
    setInputValue({ ...inputValue, timmings: updatedDays });
  };

  const [error, setError] = useState("");

  const timeToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const checkTimeConstraints = (originalArray, newArray) => {
    console.log(
      originalArray,
      newArray,
      "originalArray, newArrayoriginalArray, newArrayoriginalArray, newArray"
    );

    // Create deep copies of the arrays to avoid reference issues
    const originalArrayCopy = JSON.parse(JSON.stringify(originalArray));
    const newArrayCopy = JSON.parse(JSON.stringify(newArray));

    console.log(
      originalArrayCopy,
      newArrayCopy,
      "originalArrayCopy, newArrayCopy"
    );

    for (let i = 0; i < newArrayCopy.length; i++) {
      const newDay = newArrayCopy[i];
      if (newDay.selected) {
        const originalDay = originalArrayCopy.find(
          (day) => day.name === newDay.name
        );

        if (originalDay) {
          const newStartMin = timeToMinutes(newDay.startTime);
          const newEndMin = timeToMinutes(newDay.endTime);
          const originalStartMin = timeToMinutes(originalDay.startTime);
          const originalEndMin = timeToMinutes(originalDay.endTime);

          // Start time in newArray should not be earlier than originalArray
          if (newStartMin < originalStartMin) {
            return {
              status: false,
              message: `Error: ${newDay.name} start time (${newDay.startTime}) cannot be earlier than original start time (${originalDay.startTime}).`,
            };
          }

          // End time in newArray should not be later than originalArray
          if (newEndMin > originalEndMin) {
            return {
              status: false,
              message: `Error: ${newDay.name} end time (${newDay.endTime}) cannot be later than original end time (${originalDay.endTime}).`,
            };
          }
        }
      }
    }

    return {
      status: true,
      message: "All times are valid.",
    };
  };

  const handleDoneClick = () => {
    const anyDaySelected = inputValue?.timmings?.some((time) => time.selected);

    if (!anyDaySelected) {
      setError("Please select at least one day for your branch.");
      return;
    }

    // Use a copy of completeBranchData for validation
    const result = checkTimeConstraints(
      [...completeBranchData?.timmings], // Copy of completeBranchData.timmings
      [...inputValue.timmings] // Copy of inputValue.timmings
    );

    if (!result.status) {
      return handleSnackbarVal(true, "error", result?.message);
    }

    const selectedTimes = inputValue?.timmings
      ?.filter((time) => time.selected)
      .map(({ name, startTime, endTime }) => {
        if (!startTime || !endTime) {
          return {
            name,
            shiftStartTime: null,
            shiftEndTime: null,
            sTime: "",
            eTime: "",
          };
        }

        const shiftStartTime = moment(startTime, "HH:mm");
        const shiftEndTime = moment(endTime, "HH:mm");

        return {
          day: name,
          selected: true,
          shiftStartTime: shiftStartTime.toISOString(),
          shiftEndTime: shiftEndTime.toISOString(),
          sTime: shiftStartTime.format("HH:mm"),
          eTime: shiftEndTime.format("HH:mm"),
        };
      });

    openConfirmDialog.current.isVisible({
      ...formData,
      timmings: selectedTimes,
    });
  };

  const renderRightPart = () => (
    <Stack
      gap={2}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"flex-end"}
    >
      <GlobalButton
        variant={"contained"}
        btnText={formData?.teamType !== "add" ? "Update" : "Done"}
        handleClickBtn={handleDoneClick}
        styleProps={{
          height: 40,
          width: 100,
          fontWeight: 400,
          fontSize: "0.875rem",
        }}
      />
    </Stack>
  );
  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Team*"}
            tabs={tabs}
            activeTab={activeTab.teams}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.teams === "teamMemebrs" ? (
            <TeamMembers
              allTeamMembers={filteredTeams.reverse()}
              handleEdit={handleEdit}
              searchInput={searchInput}
              setSearchInput={setSearchInput}
              setFormData={setFormData}
              handleDelete={handleDelete}
              handleChangeTab={handleChangeTab}
              open={openDialog}
              handleChangeStatus={handleChangeStatus}
              confirmRef={confirmRef}
              setOpen={setOpenDialog}
              handleDeleteTeamMember={handleDeleteTeamMember}
            />
          ) : activeTab.teams === "addNewMember" ? (
            <AddNewMember
              user={user}
              allBranches={allBranches}
              inputError={inputError}
              setInputError={setInputError}
              handleInputChange={handleInputChange}
              setInputValue={setInputValue}
              salaryOption={salaryOption}
              setSalaryOption={setSalaryOption}
              inputValue={inputValue}
              handleSnackbarVal={handleSnackbarVal}
              handleChangeTab={handleChangeTab}
            />
          ) : activeTab.teams === "assignedService" ? (
            <ProvideService
              handleChangeTab={handleChangeTab}
              serviceData={serviceData}
              setSelectedServices={setSelectedServices}
              setSelctedID={setSelctedID}
              selectedID={selectedID}
              formData={formData}
              selectedServices={selectedServices}
              handleFetchAllServices={handleFetchAllServices}
              setSelectedCategory={setSelectedCategory}
              selectedCategory={selectedCategory}
            />
          ) : activeTab.teams === "teamMembersTimings" ? (
            <AppContainer
              primaryHeading={"Add your team member's timings"}
              secondaryHeading={
                "Set standard opening hours to show on your profile page, these hours do not impact your calendar availability."
              }
              headProps={renderRightPart()}
              showBackButton
              handleBack={() => handleChangeTab("assignedService")}
              childrenProps={{
                sx: {
                  padding: { xs: "10px 20px", md: "20px 50px" },
                  paddingBottom: "50px !important",
                },
              }}
            >
              <OpeningHours
                selectedDays={inputValue.timmings}
                setSelectedDays={handleSelecteTime}
                openConfirmDialog={openConfirmDialog}
                type={"team"}
                brancheTime={brancheTime}
                handleFetchBranhDetails={handleFetchBranhDetails}
                open={openConfirm}
                handleChangeTab={handleChangeTab}
                setOpen={setOpenConfirm}
                branchData={formData}
                completeBranchData={completeBranchData}
                handleCreateTeamMember={handleCreateTeamMember}
              />
            </AppContainer>
          ) : activeTab.teams === "sheduleShift" ? (
            <Sheduling handleChangeTab={handleChangeTab} />
          ) : null}
        </Grid>
      </Grid>
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <Loader isLoading={isLoading} />
    </NavigationDrawer>
  );
}

export default ClientTems;
